import { t } from '@lingui/core/macro';
import { type FacilityTransferRoundPublicRecord, FacilityTransferDirection } from '@navio/nsdk';
import { NoddiInfoBanner } from 'noddi-ui-web';
import { useFacilityTimeZone } from './facilityTimeZone';
import { mergeRoundsByTime } from './pickupRounds';

interface Props {
  pickupRounds: FacilityTransferRoundPublicRecord[];
}

export const PickupOrderBanner = ({ pickupRounds }: Props) => {
  const timeZone = useFacilityTimeZone();
  const pickups = mergeRoundsByTime(pickupRounds, FacilityTransferDirection.OUTGOING, timeZone);
  // One pickup has no order to follow.
  if (pickups.length <= 1) {
    return null;
  }

  const pickupCount = pickups.length;
  const times = pickups.map((pickup) => pickup.time);
  const leadingTimes = times.slice(0, -1).join(', ');
  const lastTime = times.at(-1) ?? '';
  const timeList = t`${leadingTimes} and ${lastTime}`;

  return (
    <NoddiInfoBanner
      variant='info'
      icon='Truck'
      title={t`We estimate ${pickupCount} pickups: ${timeList}`}
      texts={[
        {
          value: t`The wheel sets for each pickup must be ready by its time. Place them in the same order as in the list below, with pickup 1 closest to the exit. That makes loading faster for both parties.`
        }
      ]}
    />
  );
};
